import DecimalJS from 'decimal.js';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

var InvariantError = /*#__PURE__*/function (_Error) {
  _inherits(InvariantError, _Error);
  var _super = _createSuper(InvariantError);
  function InvariantError(message) {
    _classCallCheck(this, InvariantError);
    return _super.call(this, "InvariantError: ".concat(message));
  }
  return _createClass(InvariantError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * Asserts that the given condition is truthy
 *
 * @param condition - Either truthy or falsy value
 * @param message - An error message
 */
function invariant(condition, message) {
  if (!condition) {
    throw new InvariantError(message);
  }
}

var BigDecimal = /*#__PURE__*/function (_DecimalJS$clone) {
  _inherits(BigDecimal, _DecimalJS$clone);
  var _super = _createSuper(BigDecimal);
  function BigDecimal() {
    _classCallCheck(this, BigDecimal);
    return _super.apply(this, arguments);
  }
  _createClass(BigDecimal, null, [{
    key: "from",
    value:
    /**
     * Syntactic sugar over new BigDecimal
     */
    function from(value) {
      return new BigDecimal(value);
    }
  }, {
    key: "mean",
    value: function mean(values) {
      invariant(values.length > 1, '2+ values must be provided');
      return values.reduce(function (total, value) {
        return total.add(value);
      }).div(values.length);
    }
  }, {
    key: "rescale",
    value: function rescale(value, powerOfTen) {
      return value.mul(BigDecimal.pow(10, powerOfTen));
    }
  }]);
  return BigDecimal;
}(DecimalJS.clone({
  precision: 32,
  toExpPos: 18,
  // use fixed-point notation up to 10^+18 (included)
  toExpNeg: -19,
  // use fixed-point notation up to 10^-18 (included)
  rounding: DecimalJS.ROUND_HALF_CEIL
}));

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var ChainType;
(function (ChainType) {
  ChainType["ETHEREUM"] = "ethereum";
  ChainType["POLYGON"] = "polygon";
})(ChainType || (ChainType = {}));

var Kind;
(function (Kind) {
  Kind[Kind["NATIVE"] = 0] = "NATIVE";
  Kind[Kind["ERC20"] = 1] = "ERC20";
  Kind[Kind["FIAT"] = 2] = "FIAT";
})(Kind || (Kind = {}));
var WellKnownSymbols;
(function (WellKnownSymbols) {
  WellKnownSymbols["ETH"] = "ETH";
  WellKnownSymbols["MATIC"] = "MATIC";
  WellKnownSymbols["USD"] = "USD";
  WellKnownSymbols["USDC"] = "USDC";
})(WellKnownSymbols || (WellKnownSymbols = {}));
var NativeType;

// DO NOT EXPORT, see type export later on
(function (NativeType) {
  NativeType[NativeType["ETHER"] = 0] = "ETHER";
  NativeType[NativeType["MATIC"] = 1] = "MATIC";
})(NativeType || (NativeType = {}));
var Fiat = /*#__PURE__*/function () {
  function Fiat(name, symbol) {
    _classCallCheck(this, Fiat);
    _defineProperty(this, "kind", Kind.FIAT);
    _defineProperty(this, "decimals", 2);
    this.name = name;
    this.symbol = symbol;
  }
  _createClass(Fiat, [{
    key: "hash",
    get: function get() {
      return this.symbol;
    }
  }, {
    key: "isErc20",
    value: function isErc20() {
      return false;
    }
  }, {
    key: "isFiat",
    value: function isFiat() {
      return true;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.symbol;
    }
  }]);
  return Fiat;
}(); // DO NOT EXPORT, see type export later on
var Ether = /*#__PURE__*/function () {
  function Ether() {
    _classCallCheck(this, Ether);
    _defineProperty(this, "kind", Kind.NATIVE);
    _defineProperty(this, "type", NativeType.ETHER);
    _defineProperty(this, "name", 'Ethereum');
    _defineProperty(this, "decimals", 18);
    _defineProperty(this, "symbol", WellKnownSymbols.ETH);
    _defineProperty(this, "chainType", ChainType.ETHEREUM);
  }
  _createClass(Ether, [{
    key: "hash",
    get: function get() {
      return this.type.toString();
    }
  }, {
    key: "isErc20",
    value: function isErc20() {
      return false;
    }
  }, {
    key: "isNativeToken",
    value: function isNativeToken() {
      return true;
    }
  }, {
    key: "isFiat",
    value: function isFiat() {
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.symbol;
    }
  }]);
  return Ether;
}(); // DO NOT EXPORT, see type export later on
var Matic = /*#__PURE__*/function () {
  function Matic() {
    _classCallCheck(this, Matic);
    _defineProperty(this, "kind", Kind.NATIVE);
    _defineProperty(this, "type", NativeType.MATIC);
    _defineProperty(this, "name", 'Matic');
    _defineProperty(this, "decimals", 18);
    _defineProperty(this, "symbol", WellKnownSymbols.MATIC);
    _defineProperty(this, "chainType", ChainType.POLYGON);
  }
  _createClass(Matic, [{
    key: "hash",
    get: function get() {
      return this.type.toString();
    }
  }, {
    key: "isErc20",
    value: function isErc20() {
      return false;
    }
  }, {
    key: "isNativeToken",
    value: function isNativeToken() {
      return true;
    }
  }, {
    key: "isFiat",
    value: function isFiat() {
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.symbol;
    }
  }]);
  return Matic;
}();
// DO NOT EXPORT, see type export later on
var Erc20 = /*#__PURE__*/function () {
  function Erc20(name, decimals, symbol, address, chainType) {
    _classCallCheck(this, Erc20);
    _defineProperty(this, "kind", Kind.ERC20);
    this.name = name;
    this.decimals = decimals;
    this.symbol = symbol;
    this.address = address;
    this.chainType = chainType;
  }
  _createClass(Erc20, [{
    key: "hash",
    get: function get() {
      return "".concat(this.chainType, ":").concat(this.address);
    }
  }, {
    key: "isErc20",
    value: function isErc20() {
      return true;
    }
  }, {
    key: "isNativeToken",
    value: function isNativeToken() {
      return false;
    }
  }, {
    key: "isFiat",
    value: function isFiat() {
      return false;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.symbol, "[chain: ").concat(this.chainType, "]");
    }
  }]);
  return Erc20;
}(); // Exporting of type only is intentional
var instances = new Map();
function immutable(key, asset) {
  if (instances.has(key)) {
    return instances.get(key); // eslint-disable-line @typescript-eslint/no-non-null-assertion
  }

  instances.set(key, asset);
  return asset;
}

/**
 * Given the same chainId and address it returns the same Erc20 instance.
 * Useful for fast reference equality (===).
 *
 * @param info ERC20 token details
 * @returns Erc20
 */
function erc20(_ref) {
  var name = _ref.name,
    decimals = _ref.decimals,
    symbol = _ref.symbol,
    address = _ref.address,
    chainType = _ref.chainType;
  var asset = new Erc20(name, decimals, symbol, address, chainType);
  return immutable(asset.hash, asset);
}

/**
 * Returns the same Matic instance for Matic token on Polygon chain.
 * Useful for fast reference equality (===).
 *
 * @returns Matic
 */
function matic() {
  var asset = new Matic();
  return immutable(asset.hash, asset);
}

/**
 * Returns the same Eth instance.
 * Useful for fast reference equality (===).
 *
 * @returns Ether
 */
function ether() {
  var asset = new Ether();
  return immutable(asset.hash, asset);
}

/**
 * Returns the same instance Fiat.
 * Useful for fast reference equality (===).
 *
 * @returns Fiat
 */
function usd() {
  var asset = new Fiat('United States dollar', WellKnownSymbols.USD);
  return immutable(asset.hash, asset);
}

var Denomination = {
  gwei: function gwei(value) {
    return BigDecimal.from(value).mul(BigDecimal.pow(10, -9));
  },
  wei: function wei(value) {
    return BigDecimal.from(value).mul(BigDecimal.pow(10, -18));
  }
};
var Amount = /*#__PURE__*/function () {
  function Amount(asset, value) {
    _classCallCheck(this, Amount);
    this.asset = asset;
    this.value = value;
  }
  _createClass(Amount, [{
    key: "convert",
    value: function convert(rate) {
      return new Amount(rate.asset, this.value.mul(rate.value));
    }
  }, {
    key: "eq",
    value: function eq(amount) {
      return amount.asset === this.asset && amount.value.eq(this.value);
    }
  }, {
    key: "gt",
    value: function gt(amount) {
      invariant(this.asset === amount.asset, "Cannot compare ".concat(this.asset.symbol, " Amount with ").concat(amount.asset.symbol, " Amount"));
      return this.value.gt(amount.value);
    }
  }, {
    key: "gte",
    value: function gte(amount) {
      invariant(this.asset === amount.asset, "Cannot compare ".concat(this.asset.symbol, " Amount with ").concat(amount.asset.symbol, " Amount"));
      return this.value.gte(amount.value);
    }
  }, {
    key: "lt",
    value: function lt(amount) {
      return !this.gte(amount);
    }
  }, {
    key: "lte",
    value: function lte(amount) {
      return !this.gt(amount);
    }
  }, {
    key: "add",
    value: function add(amount) {
      invariant(this.asset === amount.asset, "Cannot add ".concat(this.asset.symbol, " Amount with ").concat(amount.asset.symbol, " Amount"));
      return new Amount(this.asset, this.value.add(amount.value));
    }
  }, {
    key: "sub",
    value: function sub(amount) {
      invariant(this.asset === amount.asset, "Cannot subtract ".concat(this.asset.symbol, " Amount with ").concat(amount.asset.symbol, " Amount"));
      return new Amount(this.asset, this.value.sub(amount.value));
    }
  }, {
    key: "mul",
    value: function mul(factor) {
      return new Amount(this.asset, this.value.mul(factor));
    }
  }, {
    key: "div",
    value: function div(divisor) {
      return new Amount(this.asset, this.value.div(divisor));
    }

    /**
     * Return the internal representation as BigDecimal truncated at the Asset max precision.
     *
     * Favour the use of Amount arithmetic methods to guarantee the maximum precision.
     *
     * Use at your own risk.
     */
  }, {
    key: "toBigDecimal",
    value: function toBigDecimal() {
      return this.value.toDecimalPlaces(this.asset.decimals, BigDecimal.ROUND_FLOOR);
    }
  }, {
    key: "toFixed",
    value: function toFixed() {
      var decimals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.asset.decimals;
      return this.value.toFixed(decimals);
    }
  }, {
    key: "toSignificantDigits",
    value: function toSignificantDigits() {
      var significantDigits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.asset.decimals;
      return this.value.toSignificantDigits(significantDigits).toString();
    }
  }, {
    key: "toNumber",
    value: function toNumber() {
      return this.value.toNumber();
    }
  }, {
    key: "isZero",
    value: function isZero() {
      return this.value.isZero();
    }
  }, {
    key: "clone",
    value: function clone(value) {
      return Amount.from(this.asset, value);
    }
  }], [{
    key: "from",
    value: function from(asset, value) {
      switch (_typeof(value)) {
        case 'string':
        case 'number':
          return new Amount(asset, new BigDecimal(value));
        default:
          return new Amount(asset, value);
      }
    }
  }, {
    key: "erc20",
    value: function erc20(asset, value) {
      return this.from(asset, value);
    }
  }, {
    key: "ether",
    value: function ether$1(value) {
      return this.from(ether(), value);
    }
  }, {
    key: "usd",
    value: function usd$1(value) {
      return this.from(usd(), value);
    }
  }, {
    key: "matic",
    value: function matic$1(value) {
      return this.from(matic(), value);
    }
  }]);
  return Amount;
}();

export { Amount as A, BigDecimal as B, ChainType as C, Denomination as D, InvariantError as I, Kind as K, NativeType as N, WellKnownSymbols as W, _inherits as _, _createSuper as a, _classCallCheck as b, _assertThisInitialized as c, _createClass as d, _wrapNativeSuper as e, _typeof as f, erc20 as g, ether as h, invariant as i, matic as m, usd as u };
